import { Injectable } from '@angular/core'
import { nginV2Headers } from '@se-po/shared-data-access-models/organization'
import { map, Observable } from 'rxjs'
import { SeFeApiService } from 'se-fe-api'
import { ApiResponse } from 'se-resource-types/dist/lib/common'
import { Affiliation } from 'se-resource-types/dist/lib/BossService'

@Injectable({
  providedIn: 'root'
})
export class AffiliationService {
  public endpoint = 'affiliations'

  constructor(
    private api: SeFeApiService
  ) {
    // noop
  }

  public findAll(orgId: string | number, params: any = {}): Observable<ApiResponse<Affiliation[]>> {
    return this.api.get<Affiliation[]>(this.endpoint, {
      params: { ancestor_organization_id: orgId, per_page: 1, ...params },
      headers: nginV2Headers
    })
  }

  public search(orgId: string | number, params: any = {}): Observable<ApiResponse<Affiliation[]>> {
    const searchParams = Object.keys(params).length
      ? { ancestor_organization_id: orgId, ...params }
      : { child_organization_id: orgId }

    return this.api.get<Affiliation[]>(`${this.endpoint}/search`, { params: searchParams, headers: nginV2Headers }).pipe(
      map(response => this.deserializeAffiliations(response))
    )
  }

  private deserializeAffiliations(response: ApiResponse<Affiliation[]>): ApiResponse<Affiliation[]> {
    if (!Array.isArray(response?.result)) return response

    return {
      ...response,
      result: response.result.map(affiliation => {
        if (!affiliation || !Object.prototype.hasOwnProperty.call(affiliation, 'child_organization')) {
          return affiliation
        }

        return {
          ...affiliation,
          child_organization: this.deserializeOrganization(affiliation?.child_organization)
        } as Affiliation
      })
    }
  }

  private deserializeOrganization(organization: any): any {
    if (!organization?.logo) return organization

    return {
      ...organization,
      logo: {
        ...organization.logo,
        url: this.validLogoUrl(organization.logo.url),
        medium: organization.logo.medium
          ? { ...organization.logo.medium, url: this.validLogoUrl(organization.logo.medium.url) }
          : organization.logo.medium
      }
    }
  }

  private validLogoUrl(url: string | null | undefined): string | null {
    const normalizedUrl = url?.trim()
    if (!normalizedUrl || this.isDefaultOrganizationPlaceholderUrl(normalizedUrl)) return null
    return normalizedUrl
  }

  private isDefaultOrganizationPlaceholderUrl(url: string): boolean {
    return /default\/organization_placeholder\.svg(?:[?#].*)?$/i.test(url)
  }
}
